import styled from "styled-components"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    padding: 40px 0;
    gap: 4px;
    flex-grow: 1;
`

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: var(--plum-gray-5);
    font-size: 40px;
`

export const Title = styled.p`
    font-size: 16px;
    font-weight: 600;
    color: var(--plum-black);
    margin: 0;
    line-height: 1.5;
`

export const Description = styled.p`
    font-size: 14px;
    color: var(--plum-gray-7);
    margin: 0;
    line-height: normal;
    max-width: 500px;
`
